<script setup lang="ts">
defineProps<{
  campaign: Campaign | null | undefined
}>()
</script>

<template>
  <UArticleContainer
    v-if="campaign?.show"
    as="section"
    class="flex flex-col items-center gap-l rounded-md bg-yellow-30 px-xl py-m text-center leading-6 text-green-50 xs:flex-row xs:text-start"
  >
    <IconsDiscount
      :value="campaign.offerPercentage"
      class="[--background:white] [--color:var(--color-coral-pop)] [--stroke:none]"
    />
    <div>
      <h4
        v-if="campaign.title"
        class="font-headline text-2xl leading-8"
        v-text="campaign.title"
      />
      <div v-if="campaign.description" v-html="campaign.description" />
    </div>
  </UArticleContainer>
</template>
